module.exports = __webpack_public_path__ + "img/churn-icon.c8f05e84.svg";